import { Box } from "grommet";
import React from "react";
import { Outlet } from "react-router-dom";
import classes from "./MedicalEmergenciesMainScreen.module.css";

function MedicalEmergenciesMainScreen() {
  return (
    <Box className={classes.mainContainer}>
      <Outlet />
    </Box>
  );
}

export default MedicalEmergenciesMainScreen;
